import { ReactComponent as Menu } from "./menu.svg";
import { SvgIcon } from "@material-ui/core";

export default function MenuButton(props) {
  return <SvgIcon {...props} component={Menu} viewBox="0 0 16 16" />;
}
